module.exports = __webpack_public_path__ + "img/kd.8063d9b2.png";